import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class MobileButtonComponent extends Vue {
    @Prop({ type: Boolean }) public disabled: boolean;
    @Prop({ type: Boolean }) public outline: boolean;
}
